import React from "react";

const Profile = () => {
  return (
    <div>
      <div className="shadow-lg bg-[#FAFAFB] max-w-lg p-5 m-auto">
        <p className="my-3 text-lg font-bold">Collector Profile</p>
        <label
          class="block text-gray-700 text-md font-bold mb-2"
          for="username"
        >
          <i class="fa-solid fa-wallet"></i> Wallets
        </label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="username"
          type="text"
          placeholder="Username"
        />
        <br />
        {/* <br />
        <label
          class="block text-gray-700 text-md font-bold mb-2"
          for="username"
        >
          <i class="fa-solid fa-envelope-circle-check"></i> Email
        </label>
        <p className="text-sm text-grey-700">
          Get alerts about lists you’ve joined and udates from PREMINT.
        </p>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="username"
          type="text"
          placeholder="Username"
        />
        <div className="bg-white my-4 p-3 rounded-lg font-semibold">
          <div className="flex justify-between items-center">
            <p>Anti-Phishing Code:</p>
            <p className="rounded-full bg-red-600 text-white px-2 py-1 text-sm">
              <i class="fa-solid fa-plus"></i> &nbsp;Please add
            </p>
          </div>

          <hr className="my-2" />
          <p className="text-[#7E7E85]">
            What is this? This is a word/string that only you know, and we will
            include rominently in every PREMINT eamil we send you. That way,
            you’ll know it’s officially from PREMINT.
          </p>
        </div> */}
        <p className="font-semibold my-2 mt-4 font-lg">
          <i class="fa-solid fa-user"></i> Social Accounts
        </p>
        <div className="bg-white-900">
          <p className="text-grey-500">
            Some projects ask you to connect a social network during the
            registration process. You can only connect a secific social account
            to one PREMINT account.
          </p>
        </div>
        <div className="bg-white mt-2 p-3 rounded-lg text-[#1DA1F2] font-semibold">
          <p>
            <i class="fa-brands fa-twitter"></i> &nbsp;Connected to twitter!
          </p>
        </div>
        <div className="bg-white mt-2 p-3 rounded-lg text-[#5865F2] font-semibold">
          <p>
            <i class="fa-brands fa-discord"></i> &nbsp;Connect to discord!
          </p>
        </div>
      </div>
    </div>
  );
};

export default Profile;
